import { userService } from '../services';

const userDetails = JSON.parse(localStorage.getItem('userDetails'));
const state = {
    userDetails: userDetails,
    menu:[],
    sezoneBranje:[],
    sezonePisanje:[]
};

const actions = {
    getLoggedIn({ commit }) {
        commit('getLoggedIn');

        userService.getLoggedIn()
            .then(
                user => commit('getLoggedInSuccess', user),
                error => commit('getLoggedInFailure', error)
            ).then(()=>{
                console.log("prišel do podatkov o sezoni!!!");
                userService.getSezone().then(
                    sezone=>{
                       
                        commit('setSezone',sezone);
                    }
                )
            }
            );
    },
    clearLoggedIn({ commit }) {
        commit('clearLoggedIn');
        
    },
    getMenu({commit })
    {
        commit('getMenu');

        userService.getMenu()
            .then(
                menu => commit('getMenu', menu),
                error => commit('getLoggedInFailure', error)
            );
    }
};

const mutations = {
    getLoggedIn(state) {
        state.userDetails = JSON.parse(localStorage.getItem('userDetails'));;
    },
    getMenu(state,menu) {
        state.menu = menu;
    },
    setSezone(state,sezone) {
        state.sezonePisanje = sezone;
        state.sezoneBranje = sezone;
    },
    clearLoggedIn(state) {
        console.log("spucam!!!");
        state.userDetails = {};
    },
    getLoggedInSuccess(state, user) {
        state.userDetails = user;
        console.log(state.userDetails);
        state.menu=state.menu.filter(i=>state.userDetails.pravice.includes(i.pravice))
    },
    getLoggedInFailure(state, error) {
        console.log(error);
        state.userDetails = { error };
    },
   
};

export const users = {
    namespaced: true,
    state,
    actions,
    mutations
};
